type FastApiDetailItem = { loc?: (string | number)[]; msg?: string };

export interface ParsedApiError {
  code: string | null;
  message: string;
}

export function parseFastApiValidationMessage(detail: unknown): string {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item: FastApiDetailItem) => item.msg || JSON.stringify(item))
      .filter(Boolean)
      .join(' ');
  }
  return 'Request could not be validated.';
}

/** Handles FastAPI string, validation-array, and structured business errors. */
export function parseApiError(
  detail: unknown,
  fallback = 'Request failed.',
): ParsedApiError {
  if (typeof detail === 'string' && detail.trim()) {
    return { code: null, message: detail };
  }
  if (Array.isArray(detail)) {
    return { code: null, message: parseFastApiValidationMessage(detail) };
  }
  if (detail && typeof detail === 'object') {
    const structured = detail as { code?: unknown; message?: unknown };
    return {
      code: typeof structured.code === 'string' ? structured.code : null,
      message:
        typeof structured.message === 'string' && structured.message.trim()
          ? structured.message
          : fallback,
    };
  }
  return { code: null, message: fallback };
}
